var map = {
	"./edu/en-US/strings.json": [
		"./src/translations/edu/en-US/strings.json",
		"src_translations_edu_en-US_strings_json"
	],
	"./health/en-US/strings.json": [
		"./src/translations/health/en-US/strings.json",
		"src_translations_health_en-US_strings_json"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = "./src/translations lazy recursive ^\\.\\/.*\\/en\\-US\\/strings\\.json$";
module.exports = webpackAsyncContext;